import { ImgIcon } from "@panwds/react-ui";
import panw_aws_logo from '../../images/panw_aws_logo.png';
import SignUpV2 from "./SignUpV2";
import styles from './styles/Register.module.scss';
import bgImage from '../../images/login-background.png';
import getUrlParameter from "../../utils/GetUrlParameter";
import { NetworkWiredIcon, PolicyIcon, SettingsIcon } from "@panwds/icons";

const Register = () => {
    const ACCOUNT_STATUS = getUrlParameter("link-state");
    return (
        <div style={{ backgroundImage: `url(${bgImage})` }} className={`${styles.backgroundCover} tw-relative tw-h-screen tw-w-full`}>
            {/* Icons in top left corner */}
            <div className={`${styles.iconsContainer}`}>
                <ImgIcon alt="Palo Design System" src={panw_aws_logo} size="xxl" />
            </div>

            {/* Content panel centered on page */}
            <div className={`${styles.contentPanel}`}>
                <div className={`${styles.contentChild} ${styles.inputContent}`}>
                    <SignUpV2 />
                </div>
                <div className={`${styles.contentChild} ${styles.helpContent}`}>
                    <div>30 Day Free Trial</div>

                    <h3>The Palo Alto Networks Cloud NGFW for AWS </h3>

                    <div>Start your 30-day free trial by setting up your tenant to immediately leverage Cloud Next-Generation Firewall capabilities in your AWS environment.</div>

                    <div className="tw-flex tw-items-center tw-gap-3">
                        <div className="tw-px-4">
                            <SettingsIcon size="xl" />
                        </div>
                        <div>
                            <div>Simple Setup</div>
                            <div className={`${styles.smallText}`}>No complex installation needed. Just fill in a few details to get your tenant ready.</div>
                        </div>
                    </div>

                    <div className="tw-flex tw-items-center tw-gap-3">
                        <div className="tw-px-4">
                            <NetworkWiredIcon size="xl" />
                        </div>
                        <div>
                            <div>Customize Your Security</div>
                            <div className={`${styles.smallText}`}>Configure your firewall settings to suit your unique security needs.</div>
                        </div>
                    </div>

                    <div className="tw-flex tw-items-center tw-gap-3">
                        <div className="tw-px-4">
                            <PolicyIcon size="xl" />
                        </div>
                        <div>
                            <div>Secure and Compliant</div>
                            <div className={`${styles.smallText}`}>Enjoy peace of mind knowing your data is protected in a secure and compliant environment.</div>
                        </div>
                    </div>

                    <div>Once you set up your account for the Cloud NGFW, you'll be able to:</div>
                    <ul className={`${styles.featureList}`}>
                        <li>Deploy quickly and manage your firewall resources seamlessly in AWS.</li>
                        <li>Monitor firewall performance and health in real-time with integrated AWS CloudWatch.</li>
                        <li>Automate security tasks with advanced firewall-as-code capabilities using APIs, CloudFormation, and Terraform.</li>
                    </ul>

                    <div>For any issues regarding your free trial, please reach out to our <a href="#">Sales Support Team</a>. For technical inquiries, kindly contact our <a href="#">Technical Support Team</a>.</div>
                </div>
            </div>
        </div>
    );
};

export default Register;
